import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceDownloadDocumentContentNotificationState = createStateReducer(
  initialState,
  {
    [events.downloadDocumentContentSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "downloadDocumentContent",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.downloadDocumentContentFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "downloadDocumentContent",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceDownloadDocumentContentNotificationState };
